/*=========================================================================================
  File Name: mutations.js
  Namespace: courses
  Description: Vuex Store - Course mutations
==========================================================================================*/

import cloneDeep from 'lodash.clonedeep'
import { buildCourseState } from './state'
import {
  ADD_FILE_CURRENT_COURSE,
  ADD_GROUP_TO_STRUCTURE,
  ADD_LEAFS_INTO_STRUCTURE,
  ADD_LEAF_TO_STRUCTURE,
  ADD_PASS_TO_COURSE_PASSES,
  CHANGE_FILE_IN_COURSE,
  REMOVE_FILE_CURRENT_COURSE,
  REMOVE_GROUP_OF_STRUCTURE,
  REMOVE_LEAF_TO_STRUCTURE,
  REMOVE_PASS_FROM_COURSE_PASSES,
  RENAME_GROUP,
  RESET_CURRENT_COURSE,
  RESET_CURRENT_COURSE_CONTENT,
  RESET_FILES_IN_COURSE,
  SAVE_HUNDRED_COURSES,
  STORE_COURSE_STRUCTURE,
  STORE_CURRENT_COURSE,
  STORE_CURRENT_COURSE_FILES,
  STORE_LIST_COURSES,
  UPDATE_CONTENT_ORDER,
} from './types'

const mutations = {
  [STORE_CURRENT_COURSE](state, course) {
    state.currentCourse = {
      ...state.currentCourse,
      ...course,
      categories: course.categories ? course.categories : [],
      learning_areas: course.learning_areas ? course.learning_areas : [],
    }
  },
  [STORE_LIST_COURSES](state, courses) {
    state.courseList = {
      ...state.quizList,
      ...courses.entries,
    }
    state.count = courses.count
    state.next = courses.next
    state.previous = courses.previous
    state.results = [...courses.results]
  },
  [STORE_COURSE_STRUCTURE](state, content) {
    state.currentCourse = {
      ...state.currentCourse,
      ...cloneDeep(content),
    }
  },
  [RESET_CURRENT_COURSE](state) {
    state.currentCourse = buildCourseState()
  },
  [RESET_CURRENT_COURSE_CONTENT](state) {
    state.currentCourse.content = []
  },
  [ADD_LEAF_TO_STRUCTURE](state, content) {
    content.parent.content.push(content.leaf)
  },
  [ADD_LEAFS_INTO_STRUCTURE](state, { afterOf, leafs }) {
    for (let i = 0; i < state.currentCourse.content.length; i++) {
      let group = state.currentCourse.content[i]
      for (let j = 0; j < group.content.length; j++) {
        let topic = group.content[j]
        for (let k = 0; k < topic.content.length; k++) {
          let leaf = topic.content[k]
          if (leaf.uuid === afterOf) {
            topic.content.splice(k + 1, 0, ...leafs)
          }
        }
      }
    }
  },
  // param content = {item, parent}
  [REMOVE_LEAF_TO_STRUCTURE](state, content) {
    const index = content.parent.content.indexOf(content.item)
    if (index > -1) {
      content.parent.content.splice(index, 1)
    }
  },
  // @params: nameObject = {oldName, newName, type, item}
  [RENAME_GROUP](state, nameObject) {
    nameObject.item.name = nameObject.newName
  },
  // @params: group = {parent, index, type}
  [ADD_GROUP_TO_STRUCTURE](state, group) {
    if (!group.parent) {
      state.currentCourse.content.splice(group.index, 0, {
        name: '',
        content_type: group.type,
        content: [],
      })
    } else {
      group.parent.content.splice(group.index, 0, {
        name: '',
        content_type: group.type,
        content: [],
      })
    }
  },
  // param content = {parent, index}
  [REMOVE_GROUP_OF_STRUCTURE](state, group) {
    if (!group.parent) {
      state.currentCourse.content.splice(group.index, 1)
    } else {
      group.parent.content.splice(group.index, 1)
    }
  },
  [UPDATE_CONTENT_ORDER](state, { item, newContent }) {
    if (item) {
      item.content = newContent
    } else {
      state.currentCourse = {
        ...state.currentCourse,
        content: newContent,
      }
    }
  },
  [ADD_FILE_CURRENT_COURSE](state, file) {
    state.currentCourse.files = [...state.currentCourse.files, file]
  },
  [REMOVE_FILE_CURRENT_COURSE](state, file) {
    const index = state.currentCourse.files.findIndex((f) => f.id === file.id)
    state.currentCourse.files.splice(index, 1)
  },
  [ADD_PASS_TO_COURSE_PASSES](state, pass) {
    state.currentCourse.direct_passes.push(pass.id)
  },
  [REMOVE_PASS_FROM_COURSE_PASSES](state, pass) {
    const index = state.currentCourse.direct_passes.findIndex(
      (id) => id === pass.id
    )
    state.currentCourse.direct_passes.splice(index, 1)
  },
  [SAVE_HUNDRED_COURSES](state, courses) {
    state.hundredCourses = courses
  },
  [STORE_CURRENT_COURSE_FILES](state, files) {
    state.currentCourseFiles = files
  },
  [CHANGE_FILE_IN_COURSE](state, payload) {
    const fileChanged =
      state.currentCourseFiles[state.currentCourseFiles.indexOf(payload.file)]
    fileChanged.name = payload.name
  },
  [RESET_FILES_IN_COURSE](state) {
    state.currentCourseFiles = []
  },
}

export default mutations
